import type { LiveCategory, LiveItem, LiveStatus } from "@/mocks/lives";

export const CATEGORY_LABELS: Record<LiveCategory, string> = {
  game: "游戏",
  entertainment: "娱乐",
  sports: "体育",
};

export const CATEGORY_ICONS: Record<LiveCategory, string> = {
  game: "ri-gamepad-line",
  entertainment: "ri-music-2-line",
  sports: "ri-basketball-line",
};

export function formatViewers(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
}

export function getCategoryLabel(category: LiveCategory): string {
  return CATEGORY_LABELS[category] ?? "其他";
}

export interface LiveFilter {
  category: LiveCategory | "all";
  status: LiveStatus | "all";
  sort: "hot" | "new";
}

export function filterLives(items: LiveItem[], filter: LiveFilter): LiveItem[] {
  const result = items.filter((item) => {
    const matchCategory = filter.category === "all" || item.category === filter.category;
    const matchStatus = filter.status === "all" || item.status === filter.status;
    return matchCategory && matchStatus;
  });
  return sortLives(result, filter.sort);
}

export function sortLives(items: LiveItem[], sort: "hot" | "new"): LiveItem[] {
  const sorted = [...items];
  if (sort === "hot") {
    sorted.sort((a, b) => b.viewers - a.viewers);
  } else {
    sorted.sort((a, b) => Number(b.id) - Number(a.id));
  }
  return sorted;
}

export function searchLives(items: LiveItem[], keyword: string): LiveItem[] {
  const query = keyword.trim().toLowerCase();
  if (!query) {
    return [];
  }
  return items.filter(
    (item) =>
      item.title.toLowerCase().includes(query) || item.streamer.toLowerCase().includes(query)
  );
}

export function getRelatedLives(items: LiveItem[], currentId: string, limit = 3): LiveItem[] {
  const current = items.find((item) => item.id === currentId);
  if (!current) {
    return sortLives(items, "hot").slice(0, limit);
  }
  const sameCategory = items.filter((item) => item.id !== currentId && item.category === current.category);
  const others = items.filter((item) => item.id !== currentId && item.category !== current.category);
  return [...sortLives(sameCategory, "hot"), ...sortLives(others, "hot")].slice(0, limit);
}

export function getLiveById(items: LiveItem[], id: string): LiveItem | undefined {
  return items.find((item) => item.id === id);
}